// @flow
export { default } from './Icon';
export type { Props } from './Icon';



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/Icon/index.js